import {
  AirIcon,
  AllProductsIcon,
  AllRequestsIcon,
  CopyIcon,
  DeleteIcon,
  ExportRequestIcon,
  FileIcon,
  FreeSalesIcon,
  GoIcon,
  HomeIcon,
  LiveAnimalIcon,
  OrganicCertIcon,
  SeaIcon,
  TransferIcon,
  UploadIcon,
  WineIcon,
} from "@tc/ui-dfe/icons"
import {
  CertificateType,
  TransportModeCode,
} from "@tc/ui-dfe/query"

export const MenuIcons = Object.freeze({
  "/": <HomeIcon fontSize="small" />,
  "/requests": <AllRequestsIcon fontSize="small" />,
  "/transfer-requests": <TransferIcon fontSize="small" />,
  "/products": <AllProductsIcon fontSize="small" />,
  "/request/transfer/start": <GoIcon fontSize="small" />,
  "/export-request": <ExportRequestIcon fontSize="small" />,
  "/request/export/start": <ExportRequestIcon fontSize="small" />,
  "/supporting-documents": <FileIcon fontSize="small" />,
  "/xml-submit": <UploadIcon fontSize="small" />,
})

export const ProductItemMoreOptions = [
  {
    value: "duplicate",
    label: "Duplicate product",
    icon: <CopyIcon />,
    disabled: false,
  },
  {
    value: "remove",
    label: "Remove product",
    icon: <DeleteIcon fill="error.main" />,
    styles: {
      color: "error.main",
    },
    disabled: false,
  },
]

export const CertificateIconMap = Object.freeze({
  [CertificateType.FreeSale]: <FreeSalesIcon sx={{ width: "24px" }} />,
  [CertificateType.Organics]: <OrganicCertIcon sx={{ width: "24px" }} />,
  [CertificateType.LiveAnimals]: <LiveAnimalIcon sx={{ width: "24px" }} />,
  [CertificateType.FreeSaleStatement]: <FreeSalesIcon sx={{ width: "24px" }} />,
  [CertificateType.ExportEligibilityStatement]: (
    <WineIcon sx={{ width: "24px" }} />
  ),
  [CertificateType.Supplementary]: <WineIcon sx={{ width: "24px" }} />,
  [CertificateType.Catch]: <ExportRequestIcon sx={{ width: "24px" }} />,
  [CertificateType.Halal]: <ExportRequestIcon sx={{ width: "24px" }} />,
  [CertificateType.Nonconsignment]: (
    <ExportRequestIcon sx={{ width: "24px" }} />
  ),
  [CertificateType.OecdSeedVarietal]: (
    <ExportRequestIcon sx={{ width: "24px" }} />
  ),
  [CertificateType.OtherDocument]: <ExportRequestIcon sx={{ width: "24px" }} />,
  [CertificateType.Phytosanitary]: <ExportRequestIcon sx={{ width: "24px" }} />,
  [CertificateType.ProductEstablishmentRegistrationDocument]: (
    <ExportRequestIcon sx={{ width: "24px" }} />
  ),
  [CertificateType.ReexportPhytosanitary]: (
    <ExportRequestIcon sx={{ width: "24px" }} />
  ),
  [CertificateType.Sanitary]: <ExportRequestIcon sx={{ width: "24px" }} />,
})

export const TransportIconMap = Object.freeze({
  [TransportModeCode.AirTransport]: (
    <AirIcon fill="primary.dark" sx={{ p: 1, height: "40px", width: "40px" }} />
  ),
  [TransportModeCode.FixedTransportInstallation]: null,
  [TransportModeCode.InlandWaterTransport]: null,
  [TransportModeCode.Mail]: null,
  [TransportModeCode.MaritimeTransport]: (
    <SeaIcon fill="primary.dark" sx={{ height: "40px", width: "40px" }} />
  ),
  [TransportModeCode.MultimodalTransport]: null,
  [TransportModeCode.NotApplicable]: null,
  [TransportModeCode.NotSpecified]: null,
  [TransportModeCode.RailTransport]: null,
  [TransportModeCode.RoadTransport]: null,
})
